import { render, staticRenderFns } from "./ListaCompraFilters.vue?vue&type=template&id=fa410a6e"
import script from "./ListaCompraFilters.vue?vue&type=script&lang=js"
export * from "./ListaCompraFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports